export default __webpack_public_path__ + "static/media/user_basic.18ef583b.svg";